import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=dbed24a4&scoped=true&"
import script from "./DashboardGrid.vue?vue&type=script&lang=js&"
export * from "./DashboardGrid.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGrid.vue?vue&type=style&index=0&id=dbed24a4&lang=scss&scoped=true&"
import style1 from "./DashboardGrid.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbed24a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer,VSwitch})
